React = require 'react/addons'
Reflux = require 'reflux'
NavigationActions = require '../actions/navigation'

module.exports = Reflux.createStore
  listenables: NavigationActions

  init: ->
    @hideNavigation = false
    @hideLogo = false
    @darkMode = false
    @areAnimationsDisabled = false

  getState: ->
    return {
      hideNavigation: @hideNavigation
      hideLogo: @hideLogo
      darkMode: @darkMode
      areAnimationsDisabled: @areAnimationsDisabled
    }

  onHideNavigation: (payload) ->
    return if @hideNavigation

    @hideNavigation = true
    @trigger @getState()

  onShowNavigation: (payload) ->
    return unless @hideNavigation

    @hideNavigation = false
    @trigger @getState()

  onHideLogo: (payload) ->
    return if @hideLogo

    @hideLogo = true
    @trigger @getState()

  onShowLogo: (payload) ->
    return unless @hideLogo

    @hideLogo = false
    @trigger @getState()

  onDisableAnimations: (payload) ->
    return if @areAnimationsDisabled

    @areAnimationsDisabled = true
    @trigger @getState()

  onEnableAnimations: (payload) ->
    return unless @areAnimationsDisabled

    @areAnimationsDisabled = false
    @trigger @getState()

  onDarkMode: (payload) ->
    return if @darkMode

    @darkMode = true
    @trigger @getState()

  onLightMode: (payload) ->
    return unless @darkMode

    @darkMode = false
    @trigger @getState()



/** WEBPACK FOOTER **
 ** ./src/scripts/stores/navigation-store.coffee
 **/